'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

FormattingService.$inject = ['FormattingConstants'];


var _module = _angular2.default.module('cb.core.forms.FormattingService', []);

_module.factory('FormattingService', FormattingService);

exports.default = _module;


function FormattingService(FormattingConstants) {
    String.prototype.format = function () {
        var formatted = this;
        for (var i = 0; i < arguments.length; i++) {
            var regexp = new RegExp('\\{' + i + '\\}', 'gi');
            formatted = formatted.replace(regexp, arguments[i]);
        }
        return formatted;
    };

    var initialExceptions = ['Adr', 'Ch', 'Chr', 'Fr', 'Fred', 'IJ', 'Jac', 'Joh', 'Ph', 'St', 'Th', 'Tj'];
    var initialExceptionsUpper = initialExceptions.map(function (ex) {
        return ex.toUpperCase();
    });

    return {
        /**
         * Formats initials, e.g. "rd" -> "R.D."
         *
         * TODO
         *
         * @param value
         * @returns {String}
         */
        formatInitials: function formatInitials(value) {
            if (!value) {
                return '';
            }

            // trim all whitespace
            value = value.replace(/\s*/g, '');

            // replace multiple periods with a single period
            value = value.replace(/\.+/g, '.');

            // remove periods at start and end of string
            value = value.replace(/^\.|\.$/g, '');

            // uppercase the whole thing
            value = value.toUpperCase();

            // replace multiple consecutive letters
            value = value.replace(/[A-Z]{2,}/g, function (m) {
                var index = initialExceptionsUpper.indexOf(m);
                if (index !== -1) {
                    return initialExceptions[index];
                }

                return m.split('').join('.');
            });

            // add a period at the end
            value += '.';

            return value;
        },

        /**
         * Formats dutch postal code, e.g. "1111aa" -> "1111 AA"
         *
         * @param value
         * @returns {String}
         */
        formatZipcode: function formatZipcode(value) {
            var parts = value.match(/([0-9]{4}) ?([a-z]{2})/i);

            if (parts === null || parts.length < 3) {
                return value;
            }

            return '{0} {1}'.format(parts[1], parts[2].toUpperCase());
        },

        /**
         * Formats license plate, e.g. "52rsj6" -> "52-RSJ-6"
         *
         * @param value
         * @returns {String}
         */
        formatLicenseplate: function formatLicenseplate(value) {
            var parts = false;

            _angular2.default.forEach(FormattingConstants.REGEX_LICENSEPLATE_FORMATTER, function (regex) {
                if (regex.test(value)) {
                    parts = value.toUpperCase().match(regex);
                }
            });

            if (parts) {
                return '{0}-{1}-{2}'.format(parts[1], parts[2], parts[3]);
            } else {
                return value;
            }
        },

        /**
         * Format phonenumber, removing the characters: [- ()]
         *
         *
         */
        formatPhonenumber: function formatPhonenumber(value) {
            return value.replace(/[- ()]/g, '');
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/formatting/formatting.service.js
// module id = 784
// module chunks = 0